import { createContext } from 'react';

export interface TenantAssetContextValue {
  tenantCode: string;
  env: string;
}

export const TenantAssetContext = createContext<TenantAssetContextValue | null>(null);
